<template>
    <el-row class="grid-stack-item">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="header">
                <h1>{{ $t('My Profile') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form :label-position="labelPosition" :model="myProfile" :rules="rules" ref="myProfile">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-row :gutter="20">
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <el-form-item :label="$t('First Name')" prop="first_name">
                                            <el-input v-model="myProfile.first_name"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                        <el-form-item :label="$t('Last Name')" prop="last_name">
                                            <el-input v-model="myProfile.last_name"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item :label="$t('Email')" prop="email">
                                    <el-input v-model="myProfile.email" readonly></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Address')" prop="address">
                                    <vue-google-autocomplete :country="['ch', 'so', 'iq']" v-model="myProfile.address"
                                        id="map" classname="el-input__inner" :value="myProfile.address" placeholder="Start typing"
                                        v-on:placechanged="getAddressData" @change="handleAddressChange"></vue-google-autocomplete>
                                </el-form-item>
                                <el-form-item :label="$t('Place')" prop="place">
                                    <el-input v-model="myProfile.place"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Zipcode')" prop="zipcode">
                                    <el-input type="zipcode" v-model="myProfile.zipcode"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('Phone')" prop="phone">
                                    <el-input v-model="myProfile.phone"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-card shadow="never">
                                    <el-form-item :label="$t('Profile Image')" prop="logo_src" class="no-margin">

                                        <el-upload ref="upload" class="avatar-uploader" action="" :on-change="handleChange"
                                            :auto-upload="false" :show-file-list="false" :before-upload="beforeAvatarUpload">
                                            <img v-if="this.myProfile.profile_image" :src="this.myProfile.profile_image"
                                                class="avatar">
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <div class="fit_to_center">
                                            <div style=" margin-top: 10px; text-align: center;">
                                                <el-button type="danger" icon="el-icon-delete" size="mini" v-if="this.myProfile.profile_image"
                                                    @click="removeProfileImage" style="text-transform: none;">{{
                                                    $t('Remove') }}</el-button>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-card>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                                <el-form-item class="no-margin">
                                    <el-button type="primary" @click="submitForm('myProfile')">{{ $t('Save') }}</el-button>
                                    <router-link tag="el-button" to="/dashboard" class="el-button--cancel">{{
                                        $t('Cancel') }}</router-link>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    import moment from "moment";
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    export default {
        components: {
            VueGoogleAutocomplete
        },
        data() {
            return {
                myProfile: {},
                formData: {},
                labelPosition: "top",
                rules: {
                    first_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    last_name: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    address: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: ['blur', 'change']
                    }],
                    place: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }],
                    zipcode: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }, {
                        pattern: /^[1-9]\d{3,4}$/,
                        trigger: ['blur', 'change'],
                        message: this.$t('Please enter valid zipcode'),
                        trigger: "blur"
                    }],
                    phone: [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: "blur"
                    }]
                }
            }
        },
        mounted() {
            this.getMyProfile();
            this.formData = new FormData();
        },
        methods: {
            getMyProfile() {
                request({
                    url: "/auth/user",
                    method: "get"
                }).then(response => {
                    this.myProfile = JSON.parse(JSON.stringify(response.data.data));
                });
            },
            handleAddressChange(address) {
                this.myProfile.address = address;
                this.$refs['myProfile'].validateField('address');
            },
            getAddressData: function (addressData, placeResultData, id) {
                this.myProfile.address = placeResultData.formatted_address;
                this.myProfile.place = placeResultData.vicinity;
                this.myProfile.zipcode = addressData.postal_code
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === "image/jpeg" || file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error(this.$t('Image type must be of JPG or PNG format'));
                }
                if (!isLt2M) {
                    this.$message.error(this.$t('Image size should not exceed to 2MB'));
                }
                return isJPG && isLt2M;
            },
            handleChange(file) {
                if (this.beforeAvatarUpload(file.raw)) {
                    this.formData.append("profile_image", file.raw);
                    this.myProfile.profile_image = URL.createObjectURL(file.raw);
                    this.myProfile.remove_profile_image = false;
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        for (var key in this.myProfile) {
                            if (this.myProfile.hasOwnProperty(key) && key !== "profile_image") {
                                this.formData.append(key, this.myProfile[key]);
                            }
                        }
                        request({
                                url: "/user/profile-update",
                                method: "post",
                                data: this.formData
                            })
                            .then(response => {
                                this.$store.commit('setConfig', {
                                    user: response.data.data
                                });
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                                // location.reload();
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            },
            removeProfileImage() {
                this.myProfile.remove_profile_image = true;
                this.myProfile.profile_image = null;
            }
        }
    }

</script>
<style scoped>
    .fit_to_center {
        width: 175px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Layout/MyProfile/MyProfile.vue